import Attachment16 from '@carbon/icons-react/es/attachment/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { Value } from '../basics';
import { Causer } from './causer';

export const MessageRelatedView: FC<{ id: string; meta }> = ({ id, meta }) => {
  const userDetails = useExternalIntegrationUserDetails(
    meta.externalUser,
    meta.by,
  );

  return (
    <FormattedMessage
      id={id}
      values={{
        causer: <Causer user={userDetails} />,
        has_content: (meta.message.content ?? '').length !== 0,
        icon: (
          <Value>
            <Attachment16 />
          </Value>
        ),
      }}
    />
  );
};
